// extracted by mini-css-extract-plugin
export default {"modal":"Sq","topline":"Tq","img":"Uq","textcontents":"Vq","heading":"Wq","copy":"Xq","link":"Yq","close":"Zq","modalinner":"ar","container":"br"};
    if(module.hot) {
      // 1713996741160
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  